(() => {
  const configElement = document.getElementById('jobski-promo-config');
  if (!configElement || window.jobskiPromoLoaded) return;
  window.jobskiPromoLoaded = true;
  const config = JSON.parse(configElement.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const marker = config.marker || 'gp_010_v1';
  const isManagedGift = (item) => ['gp_010_v1', 'gf_week_20261025'].includes(item.properties?._jobski_promo) && [55640322376009, 53038700134729].includes(item.variant_id);
  let running = null;
  let pending = false;
  let timer;
  let previousGift = false;
  let declined = false;
  let failed = false;
  const isGift = (item) => item.variant_id === config.variant && item.properties?._jobski_promo === marker;
  const eligibleTotal = (cart) => cart.items.reduce((sum, item) => sum + (isManagedGift(item) ? 0 : item.original_line_price), 0);
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error('Cart update failed');
    return data;
  };
  const noticeKey = 'jobski_gift_notice_' + marker;
  const startKey = noticeKey + '_started';
  let noticeShown = false;
  let noticeStarted = Date.now();
  try {
    noticeShown = localStorage.getItem(noticeKey) === 'shown';
    const savedStart = Number(sessionStorage.getItem(startKey));
    if (savedStart > 0) noticeStarted = savedStart;
    else sessionStorage.setItem(startKey, String(noticeStarted));
  } catch (_) {}
  const renderNotice = (text) => {
    let element = document.getElementById('jobski-promo-message');
    if (!element) {
      element = document.createElement('aside');
      element.id = 'jobski-promo-message';
      element.setAttribute('role', 'status');
      element.style.cssText = 'position:fixed;right:20px;bottom:90px;z-index:9;box-sizing:border-box;width:calc(100% - 40px);max-width:360px;padding:24px 46px 24px 22px;background:#181818;color:#f7f3ed;border:1px solid #b59a72;box-shadow:0 8px 30px #0006;font-size:14px;line-height:1.6;';
      const copy = document.createElement('p');
      copy.dataset.promoCopy = '';
      copy.style.margin = '0';
      const close = document.createElement('button');
      close.type = 'button';
      close.setAttribute('aria-label', document.documentElement.lang.startsWith('pl') ? 'Zamknij' : 'Close');
      close.textContent = '×';
      close.style.cssText = 'position:absolute;right:4px;top:4px;width:40px;height:40px;border:0;background:none;color:#f5c629;font-size:26px;cursor:pointer;';
      close.addEventListener('click', () => { element.hidden = true; });
      element.append(copy, close);
      document.body.append(element);
    }
    element.querySelector('[data-promo-copy]').textContent = text;
    element.hidden = false;
  };
  // Cart synchronization must not trigger or reset the one-time offer.
  const message = (text) => {
    if (text === config.error) renderNotice(text);
  };
  const showOffer = () => {
    if (document.querySelector('.jk-history')) return;
    try { if (localStorage.getItem(noticeKey) === 'shown') noticeShown = true; } catch (_) {}
    if (noticeShown || !config.available || config.currency !== 'PLN' || config.country !== 'PL') return;
    if (document.hidden || document.querySelector('dialog[open],cart-drawer.active,jobski-scent-finder[data-engaged],input:focus,textarea:focus')) {
      setTimeout(showOffer, 500); return;
    }
    noticeShown = true;
    try { localStorage.setItem(noticeKey, 'shown'); } catch (_) {}
    renderNotice(config.success);
  };
  if (!noticeShown && config.available && config.currency === 'PLN' && config.country === 'PL') {
    setTimeout(showOffer, Math.max(0, 12000 - (Date.now() - noticeStarted)));
  }
  const refresh = async () => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jobski-promo' });
    }
    const url = new URL(root, location.origin);
    url.searchParams.set('sections', 'cart-icon-bubble,main-cart-footer,cart-drawer');
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) return;
    const sections = await response.json();
    for (const [id, html] of Object.entries(sections)) {
      if (!html) continue;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        const drawer = document.querySelector('cart-drawer');
        const target = drawer?.querySelector('#CartDrawer');
        const source = parsed.querySelector('#CartDrawer');
        if (target && source) {
          target.innerHTML = source.innerHTML;
          drawer.classList.toggle('is-empty', parsed.querySelector('cart-drawer')?.classList.contains('is-empty') || false);
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
        }
        continue;
      }
      const target = id === 'cart-icon-bubble' ? document.getElementById(id) : document.querySelector('#main-cart-footer .js-contents');
      const source = id === 'cart-icon-bubble' ? parsed.querySelector('.shopify-section') : parsed.querySelector('.js-contents');
      if (target && source) target.innerHTML = source.innerHTML;
    }
  };
  const synchronize = async () => {
    let cart = await request('cart.js');
    let retiredRemoved = false;
    for (const retired of cart.items.filter((item) => isManagedGift(item) && !isGift(item))) {
      await request('cart/change.js', { id: retired.key, quantity: 0 });
      retiredRemoved = true;
    }
    if (retiredRemoved) cart = await request('cart.js');
    let gifts = cart.items.filter(isGift);
    const qualifies = cart.currency === 'PLN' && config.country === 'PL' && eligibleTotal(cart) >= config.threshold && config.available;
    if (!qualifies) { declined = false; failed = false; }
    if (previousGift && !gifts.length && qualifies) declined = true;
    let changed = retiredRemoved;
    for (const gift of gifts) {
      const quantity = qualifies ? (gift === gifts[0] ? 1 : 0) : 0;
      if (gift.quantity !== quantity) {
        await request('cart/change.js', { id: gift.key, quantity });
        changed = true;
      }
    }
    if (qualifies && !gifts.length && !declined && !failed) {
      await request('cart/add.js', { items: [{ id: config.variant, quantity: 1, properties: { _jobski_promo: marker } }] });
      changed = true;
    }
    if (changed) cart = await request('cart.js');
    gifts = cart.items.filter(isGift);
    const rewardItems = cart.items.filter((item) => item.variant_id === config.variant);
    const rewardSaving = rewardItems.reduce((sum, item) => sum + item.original_line_price - item.final_line_price, 0);
    const unexpectedPrice = gifts.length > 0 && (gifts.some((item) => item.quantity !== 1) || rewardSaving < gifts.reduce((sum, item) => sum + item.original_line_price, 0) - config.price);
    if (unexpectedPrice) {
      for (const gift of gifts) await request('cart/change.js', { id: gift.key, quantity: 0 });
      failed = true;
      changed = true;
      cart = await request('cart.js');
      gifts = [];
      message(config.error);
    } else {
      message(gifts.length ? config.success : '');
    }
    previousGift = gifts.length > 0;
    if (changed) await refresh();
    if (window.jobskiSyncPickupSize) cart = await window.jobskiSyncPickupSize();
    return cart;
  };
  const sync = () => {
    if (running) { pending = true; return running; }
    running = (async () => {
      let result;
      do { pending = false; result = await synchronize(); } while (pending);
      return result;
    })().catch(() => { message(config.error); throw new Error('Promotion verification failed'); })
      .finally(() => { running = null; });
    return running;
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(() => sync().catch(() => {}), 250);
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { if (event.source !== 'jobski-promo') schedule(); });
  }
  window.addEventListener('pageshow', schedule);
  document.addEventListener('cart:lines-update', schedule);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[name="checkout"], a[href="/checkout"]');
    if (!button || event.ctrlKey || event.metaKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    button.setAttribute('aria-busy', 'true');
    sync().then(() => { location.assign(root + 'checkout'); }).catch(() => {})
      .finally(() => button.removeAttribute('aria-busy'));
  }, true);
  document.addEventListener('submit', (event) => {
    if (!event.submitter?.matches('[name="checkout"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync().then(() => { location.assign(root + 'checkout'); }).catch(() => {});
  }, true);
  window.jobskiPrepareCheckout = sync;
  schedule();
})();

